import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const getBackendVersion = async (force: boolean = false) => {
  let version = storage.getBackendVersion();
  let time = storage.getServerTime();
  if (!version || force) {
    const url = `${getFunctionBaseUrl()}/api/getVersion`;
    const response = await rest.get(url);
    if (response.version_be) {
      version = "be: v" + response["version_be"] +" db: v" + response["version_db"];
      time = response["time"];
      // console.log("getBackendVersion() version " + version + " force: " + force);
      storage.setBackendVersion(version ? version : "");
      storage.setServerTime(time ? time : "");
    } else {
      return response;
    }
  }
  return version;
}